// wraps youtube iframes in aspect-ratio-boxes to ensure they fill their space and scale responsively
// currently not in use while we review the need.

// The main issue is that smush's lazy loading creates a disconnect between the iframe html and the rendered content therein
// so shifting the iframe in the dom causes the iframe to become unloaded, and there's no obvious way to trigger the lazy load manually
document.addEventListener('DOMContentLoaded', () => {
  const wrapElem = (elem) => {
    if (!elem.parentElement.matches('.aspect-ratio-box, .aspect-ratio-inner, .aspect-ratio-embed')) {
      const wrap = document.createElement('div');
      wrap.classList.add('aspect-ratio-box', 'aspect-ratio-box-16x9');
      elem.classList.add('aspect-ratio-box-inner');
      elem.parentElement.appendChild(wrap);
      wrap.appendChild(elem);
    }
  };
  document.querySelectorAll('iframe').forEach((elem) => {
    if ((elem.getAttribute('src') && elem.getAttribute('src').indexOf('youtube') >= 0) 
        || (elem.getAttribute('data-src') && elem.getAttribute('data-src').indexOf('youtube') >= 0)) {
      if (!elem.parentElement.classList.contains('aspect-ratio-box')) {
        if (elem.classList.contains('lazyloading')) {
          document.addEventListener('lazyloaded', (evt) => {
            if (evt.target == elem) {
              wrapElem(elem);
            }
          })
        } else {
          wrapElem(elem);
        }
      }
    }
  })
});